<script lang="ts">
  import FeatherIcon from "svelte-feather-icon";
  import Link from "svelte-link";
  import { Image } from "sveltestrap";
  import { sidebarClose } from "../../store";
  const responsiveSidebar = () => {
    sidebarClose.update((value) => (value = !value)) 
  };
  let imgPath : string= '/assets/images/logo';
</script>

<div class="main-header-left">
  <div class="logo-wrapper">
    <Link href="/">
      <Image fluid src="{imgPath}/logo.png" />
    </Link>
  </div>
  <div class="dark-logo-wrapper">
    <Link href="/">
      <Image fluid src="{imgPath}/dark-logo.png" />
    </Link>
  </div>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class="toggle-sidebar" on:click={()=>responsiveSidebar()}>
    <FeatherIcon
      icon="align-center"
      class="status_toggle middle"
      id="sidebar-toggle"
    />
  </div>
</div>
